import { render, staticRenderFns } from "./TableSupplyManagerPending.vue?vue&type=template&id=6f4ca398&"
import script from "./TableSupplyManagerPending.vue?vue&type=script&lang=ts&"
export * from "./TableSupplyManagerPending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports